const BaseUrl = "https://cmart.php-dev.in"
export const serverFileStoragePath = `https://careers.neosofttech.com/~careers/public/images/thumb/`

export const defaultTime = {
    time_to_read:120,
    expected_answer_time:1500
}
export const verifySpeech  = 'hello world'